// extracted by mini-css-extract-plugin
export default {"title":"Baa-z","warning":"Caa-z","sizeOptionsLegendText":"Daa-z"};